import { useMoment } from "../../../hooks";
import AppPagination from "../AppPagination";
import AppLoadingIcon from "../AppLoadingIcon";
import "./style.css";

export interface IAppTableColumn<T = any> {
  header: string;
  accessor: string;
  headerClassName?: string;
  cellClassName?: string;
  cell?: (value: T) => React.ReactNode;
  type?: "text" | "number" | "date" | "time" | "datetime" | "currency" | "boolean" | "image" | "link" | "percentage";
  url?: string;
  align?: "left" | "center" | "right";
  maxWidth?: number;
}

export interface IAppTableProps {
  title?: string;
  columns: IAppTableColumn[];
  data: any[];
  loading?: boolean;
  error?: string;
  MaxVw?: number;
  tableStyle?: "striped" | "none";
  tableClassName?: string;
  tableHeaderClassName?: string;
  tableContentClassName?: string;
  stripeClassName?: string;
  headerColor?: {
    text?: string;
    background?: string;
  };
  pagination?: {
    onChange: (page: number) => void;
    page?: number;
    size?: number;
    total?: number;
    pages?: number;
  };
}

const AppTable = ({
  title,
  columns,
  data,
  MaxVw = 100,
  loading,
  error,
  tableStyle = "striped",
  tableClassName = "",
  tableHeaderClassName = "",
  tableContentClassName = "",
  stripeClassName = "",
  pagination,
}: IAppTableProps) => {
  if (loading) {
    return (
      <div className="app-table-loading">
        <AppLoadingIcon className="mx-auto" size={40} />
      </div>
    );
  }

  return (
    <div className="app-table-wrapper">
      <div className="app-table-container">
        {title && <h2 className="app-table-title">{title}</h2>}
        <div className={`app-table-container ${tableClassName}`} style={{ maxWidth: `${MaxVw}vw` }}>
          <table className="app-table">
            <thead className={`app-table-header ${tableHeaderClassName}`}>
              <tr>
                {columns.map((column, index) => {
                  return (
                    <th key={index} className={`${column.headerClassName || ""}`}>
                      {column.header}
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {data.map((row, rowIndex) => {
                const stripeClass =
                  tableStyle === "striped"
                    ? rowIndex % 2 === 0
                      ? stripeClassName || `striped-even ${stripeClassName}`
                      : `striped-odd ${tableContentClassName}`
                    : `${tableContentClassName}`;
                return (
                  <tr key={rowIndex} className={`app-table-row ${stripeClass}`}>
                    {columns.map((column, columnIndex) => {
                      return (
                        <td key={columnIndex} className={`app-table-cell align-${column.align || "left"} ${column.cellClassName || ""}`}>
                          {column.cell ? (
                            column.cell(row)
                          ) : column.type === "percentage" ? (
                            <span className="app-table-text-nowrap">{`${row[column.accessor]}%`}</span>
                          ) : column.type === "currency" ? (
                            <span className="app-table-text-nowrap">{`R$ ${row[column.accessor].toFixed(2).replace(".", ",")}`}</span>
                          ) : column.type === "date" ? (
                            <span>{useMoment().formatDate(row[column.accessor])}</span>
                          ) : column.type === "time" ? (
                            <span>{useMoment().formatTime(row[column.accessor])}</span>
                          ) : column.type === "datetime" ? (
                            <span>{useMoment().formatDateTimeSend(row[column.accessor])}</span>
                          ) : column.type === "boolean" ? (
                            <span>{row[column.accessor] ? "Sim" : "Não"}</span>
                          ) : column.type === "image" ? (
                            <img src={row[column.accessor]} alt="" />
                          ) : (
                            row[column.accessor]
                          )}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {pagination?.onChange && (
          <AppPagination currentPage={pagination.page || 1} totalPages={pagination.pages || 0} onPageChange={pagination?.onChange} />
        )}
      </div>
    </div>
  );
};

export default AppTable;
